import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import {MobileVideo, News, NewsSource} from './types';
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";


export default class VideoList extends Control {


    private _dataTable: DataTable;
    private _dataWithFiltersNode: HTMLElement;

    _SourceId: number

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._SourceId = null
        super._initFields(settings);
    }

    _render() {
        this.np_render();
        this.addClass('');

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowSettingsButton: false,
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: false,
            EnableSort: false,
            ImageWidth: 32,
            Columns: [{
                Content: 'Id',
                Width: '10%',
                PropertyContent: 'id'
            }, {
                Content: NP.RM.getString('Title'),
                PropertyContent: 'title',
                Width: '80%'
            }, {
                Content: 'Date',
                PropertyContent: 'publishedAt',
                Width: '15%'
            }],
            EvItemClick: (s: object, e: { Item: MobileVideo }) => {
                window.open('https://www.youtube.com/watch?v=' + e.Item.id, '_blank');
            },
            ShowPaginator: false
        });

        this.refresh()
    }


    setHeight(value: number) {
        super.setHeight(value);
        this._dataTable.setHeight(value);
    }

    setWidth(value: number) {
        super.setWidth(value);
        this._dataTable.setWidth(value);
        if (this._dataTable.getIsSmall()) {

            this.setHeight(this._Height);
        } else {

            this.setHeight(this._Height);
        }
    }

    refresh() {
        this.refreshList();
    }

    private async refreshList() {
        let sources = await ServerAPI.get<MobileVideo[]>(`/video-source/${this._SourceId}`)

        this._dataTable.setRows(sources);
    }

}